import { render, staticRenderFns } from "./partTimeCandidate.vue?vue&type=template&id=38b7e25a&scoped=true"
import script from "./partTimeCandidate.vue?vue&type=script&lang=js"
export * from "./partTimeCandidate.vue?vue&type=script&lang=js"
import style0 from "./partTimeCandidate.vue?vue&type=style&index=0&id=38b7e25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7e25a",
  null
  
)

export default component.exports